import ServiceBase from "base/baseService"
import server from "infra/server"

export default class loginService extends ServiceBase {
    url = '/cadastro/login'
    frontUrl = '/cadastro/login'

    async getMenu() {

        return await server().get('cadastro/pessoa/usuario/menu').then((response) => {

            const menu = this.menuToTree({ menus: response.data })

            return this.afterMountMenu(menu)

        }).catch((error) => {
            console.log("Erro: ", error)
        })

    }

    afterMountMenu(menu) {
        return menu
    }

    menuToTree({ menus }) {

        menus.map((e) => {
            e['label'] = e.descricao_menu
            e['icon'] = e.icone_menu
            e['route'] = e.rota_web_menu
            delete e.descricao_menu
            delete e.codigo_menu
            delete e.oculto_menu
            delete e.rota_web_menu
            delete e.icone_menu
            delete e.rota_web_menu

            if (e.route == null) {
                delete e.route
            }
        })

        const arvore = []

        for (const menu of menus) {
            const partesOrdem = menu.ordem_menu.split('.')
            let nodoAtual = arvore

            for (let index = 0; index < partesOrdem.length; index++) {
                const parte = partesOrdem[index]

                if (!nodoAtual.find(node => node.ordem === parte)) {
                    const novoNodo = {
                        ordem: parte,
                        ordem_menu: menu.ordem_menu,
                        label: index === partesOrdem.length - 1 ? menu.label : null,
                        icon: menu.icon,
                        route: menu.route,
                        items: [],
                    }
                    nodoAtual.push(novoNodo)
                }

                nodoAtual = nodoAtual.find(node => node.ordem === parte).items
            }
        }

        return arvore
    }

}

